<div class="modal-content importador-csv-modal" [class.is-compacto]="modoCompacto">
  <header class="importer-header">
    <div class="header-copy">
      <h4 class="modal-title">{{titulo}}</h4>
      <p class="header-context" *ngIf="!escolheuArquivo">{{nomeCatalogo}}</p>
      <p class="header-context header-file" *ngIf="escolheuArquivo">
        <i class="mdi mdi-file-delimited-outline"></i>
        <span class="file-name">{{arquivo?.name}}</span>
        <span class="file-rows" *ngIf="!arquivoHierarquicoInsumos">
          {{quantidadeLinhasArquivo}} linhas
        </span>
        <span class="file-rows" *ngIf="arquivoHierarquicoInsumos">
          {{totalCadastrosArquivo}} cadastros · {{totalIngredientesArquivo}} ingredientes
        </span>
      </p>
    </div>
    <button type="button" class="header-close" aria-label="Fechar importador" (click)="feche()">
      <i class="mdi mdi-close"></i>
    </button>
  </header>

  <div class="modal-body">
    <div class="feedback feedback-danger" role="alert" aria-live="assertive" *ngIf="mensagemErro">
      <span class="feedback-icon"><i class="mdi mdi-alert-circle-outline"></i></span>
      <div>
        <strong>Não foi possível continuar</strong>
        <p>{{mensagemErro}}</p>
      </div>
      <button type="button" aria-label="Fechar mensagem" (click)="fecheMensagemErro()">
        <i class="mdi mdi-close"></i>
      </button>
    </div>

    <div class="importacao-step" [hidden]="!buscarProdutos || importando || importou">
      <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
            novalidate #frm="ngForm" (ngSubmit)="onSubmit()">

        <section class="etapa-arquivo" *ngIf="!escolheuArquivo" aria-labelledby="arquivo-csv-titulo">
          <h5 id="arquivo-csv-titulo" class="sr-only">Selecione o arquivo CSV</h5>

          <kendo-fileselect
            id="arquivo"
            name="arquivo"
            (select)="selecionouArquivo($event)"
            [(ngModel)]="files"
            [multiple]="false"
            [restrictions]="restricoes"
            required>
            <kendo-fileselect-messages
              select="Escolher arquivo"
              dropFilesHere="Arraste seu CSV para cá"
              clearSelectedFiles="Remover">
            </kendo-fileselect-messages>
          </kendo-fileselect>

          <p class="formato-resumo" *ngIf="!modoInsumos">
            O arquivo precisa de uma coluna
            <b>{{somentePrecos ? 'CodigoPDV' : 'Nome'}}</b> e uma <b>Preço</b>. Todo o resto é opcional.
          </p>
          <p class="formato-resumo" *ngIf="modoInsumos">
            Arquivos simples precisam de <b>Nome</b> e <b>Unidade-base</b>. Fichas técnicas precisam
            conter também todas as linhas de composição e seus ingredientes.
          </p>

          <details class="formato-detalhes">
            <summary>
              <i class="mdi mdi-chevron-right"></i>
              Ver as {{colunasAceitas.length}} colunas que o sistema entende
            </summary>
            <div class="colunas-aceitas">
              <span *ngFor="let coluna of colunasAceitas">{{coluna}}</span>
            </div>
            <p class="formato-nota" *ngIf="!somentePrecos && !modoInsumos">
              O cabeçalho é reconhecido sozinho, na ordem que estiver. Para adicionais configuráveis,
              use <b>TipoLinha</b>, <b>Referencia</b> e <b>ReferenciaPai</b>.
            </p>
            <p class="formato-nota" *ngIf="modoInsumos">
              O cabeçalho é reconhecido sozinho, na ordem que estiver. Grupos inexistentes serão criados;
              a Unidade-base precisa estar cadastrada e o saldo inicial será zero. A importação é integral:
              se faltar algum ingrediente, nenhum cadastro será criado. Os campos técnicos das fichas são
              identificados e processados automaticamente.
            </p>
          </details>
        </section>

        <section class="mapping-card" *ngIf="escolheuArquivo" aria-labelledby="mapeamento-titulo">
          <div class="mapping-header">
            <div class="mapping-copy">
              <h5 id="mapeamento-titulo">
                {{visaoSimplificadaInsumos ? 'Confira os cadastros' : 'Confira as colunas'}}
              </h5>
              <p *ngIf="!visaoSimplificadaInsumos">
                {{quantidadeColunasMapeadas}} de {{colunasImportar.length}} colunas reconhecidas.
                Ajuste só o que estiver errado.
              </p>
              <p *ngIf="visaoSimplificadaInsumos">
                {{totalCadastrosArquivo}} cadastros encontrados. Os {{totalIngredientesArquivo}}
                ingredientes serão importados automaticamente com suas fichas.
              </p>
            </div>

            <div class="mapping-controls">
              <button type="button" class="advanced-toggle"
                      *ngIf="arquivoHierarquicoInsumos"
                      (click)="altereExibicaoDetalhesAvancadosInsumos()">
                <i class="mdi"
                   [ngClass]="exibirDetalhesAvancadosInsumos ? 'mdi-eye-off-outline' : 'mdi-code-tags'"></i>
                {{exibirDetalhesAvancadosInsumos ? 'Ocultar detalhes avançados' : 'Exibir detalhes avançados'}}
              </button>

              <div class="decimal-switch">
                <span class="decimal-switch-label">
                  {{modoInsumos ? 'Quantidades' : 'Preços'}}
                  <small *ngIf="separadorDecimalDetectado">detectado no arquivo</small>
                </span>
                <div class="decimal-options" role="radiogroup"
                     [attr.aria-label]="modoInsumos ? 'Formato das quantidades' : 'Formato dos preços'">
                  <button type="button"
                          *ngFor="let opcao of opcoesSeparadorDecimal"
                          role="radio"
                          [class.is-selected]="separadorDecimal?.codigo === opcao.codigo"
                          [attr.aria-checked]="separadorDecimal?.codigo === opcao.codigo"
                          (click)="escolhaSeparadorDecimal(opcao)">
                    {{exemploPreco(opcao)}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="preview-table-container">
            <div class="table-responsive-wrapper" (wheel)="rodouMouseNaTabela($event)">
              <table class="table">
                <thead>
                  <tr>
                    <th *ngFor="let item of colunasImportarVisiveis"
                        class="column-header"
                        [class.is-ignorada]="colunaIgnorada(item)">
                      <div class="source-column">
                        <small>Coluna do arquivo</small>
                        <strong [title]="conteudoArquivo[0][item.indice]">
                          {{conteudoArquivo[0][item.indice] || 'Sem título'}}
                        </strong>
                      </div>
                      <div class="column-mapping">
                        <span class="automatic-mapping" *ngIf="mapeamentoAutomaticoInsumos(item)">
                          <i class="mdi mdi-lock-check-outline"></i>
                          Mapeado automaticamente
                        </span>
                        <kendo-dropdownlist
                          *ngIf="!mapeamentoAutomaticoInsumos(item)"
                          name="colunaImportar{{item.indice+1}}"
                          [data]="opcoesColuna"
                          class="form-control form-control-sm"
                          textField="descricao"
                          placeholder="Não importar"
                          [(ngModel)]="item.coluna">
                        </kendo-dropdownlist>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let linha of primeirasLinhas()" [ngClass]="{'table-danger': linha?.erro}">
                    <td *ngFor="let item of colunasImportarVisiveis"
                        class="data-cell"
                        [class.is-ignorada]="colunaIgnorada(item)">
                      <div class="cell-content" [title]="valorPrevia(linha, item)">
                        {{valorPrevia(linha, item)?.length > 34 ?
                          valorPrevia(linha, item).substring(0, 34) + '…' :
                          valorPrevia(linha, item) || '—'}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <div class="form-actions" *ngIf="escolheuArquivo">
          <button type="button" class="btn btn-ghost" (click)="limpeArquivo()">
            <i class="mdi mdi-swap-horizontal"></i>
            Trocar arquivo
          </button>

          <div class="action-buttons">
            <p class="pendencia" *ngIf="camposObrigatoriosPendentes.length">
              <i class="mdi mdi-alert-outline"></i>
              Falta apontar {{camposObrigatoriosPendentes.join(' e ')}}
            </p>

            <button type="button" class="btn btn-quiet" (click)="feche()">
              Cancelar
            </button>

            <button type="submit"
                    class="btn btn-import"
                    [disabled]="!podeImportar || importando || carregando">
              <i class="k-icon k-i-loading" *ngIf="importando || carregando"></i>
              <i class="mdi"
                 *ngIf="!importando && !carregando"
                 [ngClass]="somentePrecos ? 'mdi-cash-refund' : 'mdi-database-import'"></i>
              {{modoInsumos ? 'Importar insumos' : (somentePrecos ? 'Conferir preços' : 'Importar catálogo')}}
            </button>
          </div>
        </div>
      </form>
    </div>

    <section *ngIf="importando" class="process-state" aria-live="polite">
      <div class="process-visual">
        <span class="process-ring"></span>
        <i class="mdi mdi-database-import"></i>
      </div>
      <h5>{{modoInsumos ? 'Importando insumos' : 'Importando seu catálogo'}}</h5>
      <p *ngIf="!modoInsumos">Estamos criando produtos, adicionais e opções. Não feche esta janela.</p>
      <p *ngIf="modoInsumos">Estamos criando insumos e grupos. Não feche esta janela.</p>
    </section>

    <section *ngIf="importou" class="completion-state" aria-live="polite">
      <div class="completion-icon"><i class="mdi mdi-check"></i></div>
      <h5>{{modoInsumos ? 'Importação concluída' : 'Catálogo atualizado'}}</h5>
      <p>{{mensagemSucesso}}</p>
      <button type="button" class="btn btn-import" (click)="feche()">
        Concluir
      </button>
    </section>

    <div [hidden]="buscarProdutos">
      <div class="feedback feedback-info" *ngIf="tudoSincronizado" role="status">
        <span class="feedback-icon"><i class="mdi mdi-check-all"></i></span>
        <div>
          <strong>Preços já sincronizados</strong>
          <p>Não encontramos nenhum preço que precise ser atualizado.</p>
        </div>
      </div>

      <app-painel-importacao-produtos
        #painelImportacao
        [hidden]="tudoSincronizado">
      </app-painel-importacao-produtos>
    </div>
  </div>

  <div class="modal-footer sync-footer" [hidden]="buscarProdutos">
    <button type="button" class="btn btn-quiet" (click)="volteTela()">
      <i class="mdi mdi-arrow-left"></i>
      Voltar
    </button>
    <button type="button"
            class="btn btn-import"
            (click)="painelImportacao.sincronizeTodos()"
            [disabled]="tudoSincronizado || painelImportacao.importacao.sincronizando">
      <i class="k-icon k-i-loading" *ngIf="painelImportacao.importacao.sincronizando"></i>
      <i class="mdi mdi-sync" *ngIf="!painelImportacao.importacao.sincronizando"></i>
      Atualizar todos
    </button>
  </div>
</div>
